// src/pages/workout/condition_guide/MSKExerciseGuide/video/detail.jsx
import { useMemo, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useLoadingGate } from "../../../../../../hooks/useLoadingGate";
import BottomNav from "../../../../../../components/common/BottomNav";
import { resolveVidPath } from "../../../../../../utils/videoSource";
import VideoDetailCard from "../../../../../../components/video/VideoDetailCard";

// guide가 배열/단일 문자열일 때 모두 처리
const ensureArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);

export default function MSKVideoDetail() {
    const ready = useLoadingGate();
    const navigate = useNavigate();
    const [sp] = useSearchParams();
    const { state: fromState = {} } = useLocation();

    // 쿼리
    const v = sp.get("v") || "";
    const cat = sp.get("cat") || "";
    const item = sp.get("item") || "";
    const titleFromQS = sp.get("title");

    // 목록에서 넘겨준 state 우선 사용
    const data = useMemo(
        () => ({
            title: fromState.title ?? titleFromQS ?? "운동 영상",
            poster: fromState.poster ?? "",
            guide: ensureArray(fromState.guide),
            videoUrl: fromState.videoUrl ?? null,
        }),
        [fromState, titleFromQS]
    );

    // HLS 경로
    const vidPath = useMemo(() => (v ? resolveVidPath(v) : ""), [v]);
    const hasAnyInfo = !!vidPath || !!data.videoUrl; // (필요하면 사용)

    // 파라미터 누락 여부
    const paramMissing = !v || !cat || !item;

    useEffect(() => {
        if (paramMissing) {
            const qs = new URLSearchParams({ cat, item }).toString();
            navigate(`/workout/conditionguide/msk/video?${qs}`, {
                replace: true,
            });
        }
    }, [paramMissing, cat, item, navigate]);

    if (paramMissing) return null;

    return (
        <main className="h-[var(--app-height)] flex flex-col font-suit overflow-y-auto scrollbar-hide px-7 md:px-8 bg-white">
            {!ready ? (
                <div className="flex-1" />
            ) : (
                <VideoDetailCard
                    title={data.title}
                    poster={data.poster}
                    guide={data.guide}
                    vidPath={vidPath}
                    videoUrl={data.videoUrl ?? ""}
                    onBack={() => navigate(-1)}
                />
            )}

            <BottomNav className="h-16 md:h-[72px]" />
        </main>
    );
}
